import { gql } from '@apollo/client';

export const fragments = {
  all: gql`
    fragment UserData on User {
      id
      name
      email
      notificationNumbers
      subscribedToOpenPositionNotifications
      sensorEmailNotifications
      sensorPhoneNotifications
      role
      roles
      dateCreated
      lastLogin
      patientNameFormat
      lockdown
      hasPassword
      staffCostAccess
      reportDeliveryEmail
      reportDeliverySms
    }
  `,
};

export const list = gql`
  query users {
    users {
      ...UserData
    }
  }
  ${fragments.all}
`;

export const organizationUserOptions = gql`
  query users {
    users {
      id
      name
      email
      notificationNumbers
      reportDeliveryEmail
      reportDeliverySms
    }
  }
`;

export const item = gql`
  query user($id: Long!) {
    user(id: $id) {
      ...UserData
    }
  }
  ${fragments.all}
`;

export const create = gql`
  mutation createUser(
    $name: String!
    $email: String!
    $role: EMembershipRole!
    $patientNameFormat: PatientNameFormat!
    $notificationNumbers: String
  ) {
    createUser(
      name: $name
      email: $email
      role: $role
      patientNameFormat: $patientNameFormat
      notificationNumbers: $notificationNumbers
    ) {
      ...UserData
    }
  }
  ${fragments.all}
`;

export const update = gql`
  mutation editUser(
    $id: Long!
    $name: String
    $email: String
    $role: EMembershipRole
    $patientNameFormat: PatientNameFormat
    $notificationNumbers: String
    $subscribedToOpenPositionNotifications: Boolean
    $sensorEmailNotifications: Boolean
    $sensorPhoneNotifications: Boolean
    $staffCostAccess: Boolean
    $reportDeliveryEmail: Boolean
    $reportDeliverySms: Boolean
  ) {
    editUser(
      id: $id
      name: $name
      email: $email
      role: $role
      patientNameFormat: $patientNameFormat
      notificationNumbers: $notificationNumbers
      subscribedToOpenPositionNotifications: $subscribedToOpenPositionNotifications
      sensorEmailNotifications: $sensorEmailNotifications
      sensorPhoneNotifications: $sensorPhoneNotifications
      staffCostAccess: $staffCostAccess
      reportDeliveryEmail: $reportDeliveryEmail
      reportDeliverySms: $reportDeliverySms
    ) {
      ...UserData
    }
  }
  ${fragments.all}
`;

export const remove = gql`
  mutation deleteUser($id: Long!) {
    deleteUser(id: $id)
  }
`;

export const clearLockdown = gql`
  mutation clearLockdown($id: Long!) {
    clearLockdown(id: $id)
  }
`;

export const setPhysicianRepresentationMutation = gql`
  mutation setPhysicianRepresentation($userId: Long!, $physicianIds: [Long!]!) {
    setPhysicianRepresentation(userId: $userId, physicians: $physicianIds)
  }
`;

export const removePhysicianRepresentationMutation = gql`
  mutation removePhysicianRepresentation($userId: Long!) {
    removePhysicianRepresentation(userId: $userId)
  }
`;

export const monitoringUsers = gql`
  query monitoring {
    monitoring {
      id
      name
    }
  }
`;

export const groupAdminUsers = gql`
  query groupAdmin {
    groupAdmin {
      id
      name
    }
  }
`;

/**
 * Paginated query for users.
 * Uses SQL LIMIT/OFFSET for efficient server-side pagination.
 */
export const usersPaginatedQuery = gql`
  query usersPaginated($offset: Int, $limit: Int, $sortBy: String, $sortOrder: String, $name: String, $role: String) {
    usersPaginated(offset: $offset, limit: $limit, sortBy: $sortBy, sortOrder: $sortOrder, name: $name, role: $role) {
      ...UserData
    }
  }
  ${fragments.all}
`;

/**
 * Count query for users.
 * Returns total count for pagination controls.
 */
export const usersCountQuery = gql`
  query usersCount {
    usersCount
  }
`;

/**
 * Subscription for users (for real-time updates).
 */
export const usersSubscription = gql`
  subscription users {
    users {
      ...UserData
    }
  }
  ${fragments.all}
`;

export default {
  list,
  item,
  create,
  update,
  remove,
  usersPaginatedQuery,
  usersCountQuery,
  usersSubscription,
};
